module.exports = __webpack_public_path__ + "static/media/joyable1.5843af1e.jpg";